import React, { MouseEvent } from 'react';
import { CoreButtonView, CoreImageView, CoreTextView, type TCoreButtonViewProps } from '@core/widgets';
import { TButtonOption } from '../../types/options';
import { TViewCommonOption, TWidget } from '@libs/types';
import { getHref } from '../Image/imageUtils';

class TButtonData {}

type TButtonSocialView = {
    widget?: TWidget<TButtonData, TButtonOption>;
    uid: string;
    label?: string;
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
    authProvider: 'apple' | 'google';
    margin?: TButtonOption['margin'];
    isCircle?: boolean;
    parentStyleNames?: string[];
} & Pick<TViewCommonOption, 'isDisabled' | 'isHide' | 'styleName' | 'style' | 'parentStyleNames'>;

export const ButtonSocialView = ({
    widget,
    uid,
    label,
    isHide,
    authProvider,
    isDisabled,
    styleName,
    parentStyleNames,
    isCircle = true,
    onClick,
}: TButtonSocialView) => {
    const resolvedWidget: TCoreButtonViewProps['widget'] = (widget ?? { uid, data: {}, options: {} }) as TCoreButtonViewProps['widget'];
    const isGoogleAuth = authProvider === 'google';
    const iconName = isGoogleAuth ? 'ic_google_sign_up' : 'ic_apple_sign_up';
    if (isCircle) {
        return (
            <CoreButtonView
                widget={resolvedWidget}
                text={label}
                isDisabled={isDisabled}
                isHide={isHide}
                parentStyleNames={parentStyleNames}
                styleName={styleName}
                styleProps={{
                    width: 56,
                    height: 56,
                    borderRadius: 56,
                    borderStroke: 1,
                    outline: 'var(--color-grey_16_lc)',
                    hovered: {
                        main: 'var(--color-grey_16_lc)',
                    },
                    pressed: {
                        outline: 'var(--color-grey_16_lc)',
                        main: 'var(--color-grey_8_lc)',
                    },
                }}
                onClick={onClick ?? (() => undefined)}
            >
                <CoreImageView
                    src={getHref(iconName)}
                    parentStyleNames={parentStyleNames}
                    styleProps={{ width: 24, height: 24, iconColor: 'var(--color-black)' }}
                />
            </CoreButtonView>
        );
    }
    const textColor = 'var(--color-permanent_black)';
    const borderColor = 'var(--color-permanent_black)';
    const backgroundColor = 'var(--color-permanent_white)';

    return (
        <CoreButtonView
            widget={resolvedWidget}
            text={label}
            isDisabled={isDisabled}
            isHide={isHide}
            parentStyleNames={parentStyleNames}
            styleName={styleName}
            styleProps={{
                fillContainer: true,
                height: 56,
                borderRadius: 56,
                borderStroke: 1,
                main: backgroundColor,
                outline: borderColor,
                hovered: {
                    main: 'var(--color-button-white-hovered)',
                    outline: borderColor,
                },
                pressed: {
                    main: 'var(--color-button-white-pressed)',
                    outline: borderColor,
                },
            }}
            onClick={onClick ?? (() => undefined)}
        >
            <CoreImageView
                src={getHref(iconName)}
                parentStyleNames={parentStyleNames}
                styleProps={{ width: 24, height: 24, iconColor: 'var(--color-permanent_black)' }}
            />
            <CoreTextView text={label} as="span" parentStyleNames={parentStyleNames} styleProps={{ main: textColor }} />
        </CoreButtonView>
    );
};
